import { useEffect, useRef, useState } from 'react';

export function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current as T;
}

export const useKeyPress = (
  targetKey: string,
  targetKeyCode?: number | string
): boolean => {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = ({ keyCode, which, key }: KeyboardEvent): void => {
      if (
        keyCode === targetKeyCode ||
        which === targetKeyCode ||
        key === targetKey
      ) {
        setKeyPressed(true);
      }
    };

    const upHandler = ({ keyCode, which, key }: KeyboardEvent): void => {
      if (
        keyCode === targetKeyCode ||
        which === targetKeyCode ||
        key === targetKey
      ) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return (): void => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey, targetKeyCode]);

  return keyPressed;
};
